import { Routes } from '@angular/router';
import { Home } from './components/pages/home/home';
import { PageComponent } from './components/pages/page-component/page-component';
import { ArticlesComponent } from './components/pages/articles-component/articles-component';
import { ArticleComponent } from './components/pages/article-component/article-component';
import { PlainteComponent } from './components/pages/plainte/plainte';
import { SignalementComponent } from './components/pages/signalement/signalement';
import { AnnuaireComponent } from './components/pages/annuaire/annuaire';
import { AnnuaireDetailComponent } from './components/pages/annuaire-detail/annuaire-detail';
import { SuiviPlainteComponent } from './components/pages/suivi-plainte/suivi-plainte';
import { GalerieComponent } from './components/pages/galerie/galerie';
import { GalerieDetailComponent } from './components/pages/galerie-detail/galerie-detail';
import { LoiComponent } from './components/pages/loi/loi';
import { LoiDetailComponent } from './components/pages/loi-detail/loi-detail';
import { DocumentsComponent } from './components/pages/documents/documents';
import { ContactComponent } from './components/pages/contact/contact';
import { PaiementComponent } from './components/pages/paiement/paiement';

export const routes: Routes = [
  { path: '',                 component: Home },
  { path: 'page/:slug',       component: PageComponent },
  { path: 'articles',         component: ArticlesComponent },
  { path: 'articles/:slug',   component: ArticleComponent },
  { path: 'plainte',          component: PlainteComponent },
  { path: 'signalement',      component: SignalementComponent },
  { path: 'annuaire',                    component: AnnuaireComponent },
  { path: 'annuaire/agence/:id',        component: AnnuaireDetailComponent },
  { path: 'annuaire/influenceur/:id',   component: AnnuaireDetailComponent },
  { path: 'annuaire/calligraphe/:id',   component: AnnuaireDetailComponent },
  { path: 'suivi-plainte',    component: SuiviPlainteComponent },
  { path: 'galerie',          component: GalerieComponent },
  { path: 'galerie/:id',      component: GalerieDetailComponent },
  { path: 'loi',              component: LoiComponent },
  { path: 'loi/:id',          component: LoiDetailComponent },
  { path: 'documents',        component: DocumentsComponent },
  { path: 'contact',          component: ContactComponent },
  { path: 'paiement',         component: PaiementComponent },

  // ── L'Autorité : organes, comités, anciens présidents ──────────────────
  { path: 'autorite/bureau',
    loadComponent: () => import('./components/pages/autorite/bureau/bureau').then(m => m.BureauComponent) },
  { path: 'autorite/comites',
    loadComponent: () => import('./components/pages/autorite/comites/comites').then(m => m.ComitesComponent) },
  { path: 'autorite/comites/:slug',
    loadComponent: () => import('./components/pages/autorite/comite-detail/comite-detail').then(m => m.ComiteDetailComponent) },
  { path: 'autorite/anciens-presidents',
    loadComponent: () => import('./components/pages/autorite/anciens-presidents/anciens-presidents').then(m => m.AnciensPresidentsComponent) },
  { path: 'autorite/anciens-presidents/:id',
    loadComponent: () => import('./components/pages/autorite/president-detail/president-detail').then(m => m.PresidentDetailComponent) },

  // ── Pages d'erreur humaines ────────────────────────────────────────────
  { path: '403',
    loadComponent: () => import('./components/pages/error-page/error-page').then(m => m.ErrorPageComponent),
    data: { code: 403 } },
  { path: '500',
    loadComponent: () => import('./components/pages/error-page/error-page').then(m => m.ErrorPageComponent),
    data: { code: 500 } },

  // Route inconnue → 404 (au lieu d'une redirection silencieuse)
  { path: '**',
    loadComponent: () => import('./components/pages/error-page/error-page').then(m => m.ErrorPageComponent),
    data: { code: 404 } },
];
